<script>
import Papa from 'papaparse'
import { ref } from 'vue'
import JsBarcode from 'jsbarcode';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import BarcodesComp from '@/components/BarcodesComp.vue'



export default {
  props: {
    value: String,
  },
  components: {
    BarcodesComp
  },
  data() {
    return {
      productsCSV: [],
      barcodeValue: '',
      barcodeList: [],
      currentPos: 0,
      linesArray:[],
      updateAll: false
    }
  },
  methods: {
    createBarcode(){

        if(this.barcodeValue){


            while (this.barcodeValue.charAt(0) === '0') {
              this.barcodeValue = this.barcodeValue.substring(1)
            }
            // const barc = this.barcodeValue
            console.log(this.barcodeValue)
            var product = this.productsCSV.filter(
                (el) => el['Variant Barcode'] === this.barcodeValue.toString(),
            )[0]
            console.log(product)
            if (typeof product !== 'undefined') {
                console.log(product)
                console.log(product['Title'])
                var itemName = product['Title']

                var size = ''
                var color = ''
                if (product['Option1 Value'].length > 2) {
                size = product['Option2 Value']
                color = product['Option1 Value']
                } else {
                size = product['Option1 Value']
                color = product['Option2 Value']
                }
                var sku = product['Variant SKU']
                var price = String('$' + product['Variant Price'])
                var sizeCol = String(size + ' / ' + color)

                // var svgBarcode = JsBarcode("#barcode", barc, {
                //     format: "CODE128",
                //     // lineColor: "",
                //     // width:4,
                //     height:20,
                //     displayValue: true
                // });

                this.barcodeList[this.currentPos] = {
                    barcode: this.barcodeValue,
                    name: itemName,
                    SKU: sku,
                    // SVG: svgBarcode,
                    sizeCol: sizeCol,
                    price: price
                }

            }else{
                console.log("Undefined product")
            }


            this.barcodeList.push(this.barcodeValue)
            this.currentPos += 1
            this.barcodeValue = ''
            console.log(this.barcodeList)
        }
    },
    createBarcodeBulk(){

        if(this.barcodeBulk){
          this.linesArray = this.barcodeBulk.split(' ');
          console.log(this.linesArray)

          for(var i = 0; i < this.linesArray.length; i ++){
            while (this.linesArray[i].charAt(0) === '0') {
              this.linesArray[i] = this.linesArray[i].substring(1)
            }
            var product = this.productsCSV.filter(
                (el) => el['Variant Barcode'] === this.linesArray[i].toString(),
            )[0]

            if (typeof product !== 'undefined') {
                console.log(product)
                console.log(product['Title'])
                var itemName = product['Title']

                var size = ''
                var color = ''
                if (product['Option1 Value'].length > 2) {
                size = product['Option2 Value']
                color = product['Option1 Value']
                } else {
                size = product['Option1 Value']
                color = product['Option2 Value']
                }
                var sku = product['Variant SKU']
                var price = String('$' + product['Variant Price'])
                var sizeCol = String(size + ' / ' + color)


                this.barcodeList[i] = {
                    barcode: this.linesArray[i],
                    name: itemName,
                    SKU: sku,
                    // SVG: svgBarcode,
                    sizeCol: sizeCol,
                    price: price
                }

            }else{
                console.log("Undefined product")
            }
            this.barcodeList.push(this.linesArray[i])
            // this.currentPos += 1
            // this.linesArray[i] = ''
            console.log(this.barcodeList)
          }
        }
    },
    handleFileUploadProd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.productsCSV = results.data;
            console.log("Parsing complete:", this.productsCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    },
    updateEverything(){
      this.updateAll = !this.updateAll
      console.log("updated : " + this.updateAll)
    },
    async generatePDF(){
      const elements = document.querySelectorAll('.page-content');
      // 1. Define a custom square size (e.g., 200mm x 200mm)
      const pageSize = 200;
      const pdf = new jsPDF({
        orientation: 'l',
        unit: 'px',
        format: [pageSize, pageSize] // Sets the PDF itself to be square
      });

      for (let i = 0; i < elements.length; i++) {
        const canvas = await html2canvas(elements[i], { scale: 5 }); // High scale for crispness
        const imgData = canvas.toDataURL('image/png');

        if (i > 0) pdf.addPage([pageSize, pageSize]);

        // 2. Place image at (0,0) and stretch to the full pageSize
        pdf.addImage(imgData, 'PNG', 0, 0, pageSize, pageSize);
      }
      pdf.save('Argent-Barcodes.pdf');
    },


        //test barcode
        //30058633
        //97609353
        //04061833

  },

}
</script>

<template>
  <h1>Print Barcode Labels</h1>
    <p>How to use:</p>
    <p>Paste list of UPC numbers. Labels will generate, then hit update to create barcodes. Generate PDF and print.</p>

    <input v-if="!productsCSV.length" id="choose-file" type="file" @change="handleFileUploadProd" accept=".csv" />
    <!-- <div>
        <input v-model="barcodeValue" @keyup.enter="createBarcode" placeholder="Enter barcode value" />

    </div> -->
    <div>
      <input v-model="barcodeBulk" @keyup.enter="createBarcodeBulk" placeholder="Enter barcode bulk" />
    </div>
    <button @click="updateEverything">Update</button>
    <button @click="generatePDF">Generate PDF</button>




    <div v-for="(barcodes, barcodeIndex) in barcodeList" :key="barcodeIndex" class="barcodes">
        <div class="page-content">
            <BarcodesComp :barcodeValue="this.barcodeList[barcodeIndex].barcode" :itemName="this.barcodeList[barcodeIndex].name" :sizeCol="this.barcodeList[barcodeIndex].sizeCol" :sku="this.barcodeList[barcodeIndex].SKU" :price="this.barcodeList[barcodeIndex].price" :index="barcodeIndex" :updateAll="this.updateAll"/>
        </div>

    </div>

</template>

<style lang="scss" scoped>
.page-content{
    margin: auto;
    height:200px;
    width: 200px;
    max-width: 200px;
    max-height: 200px;
    // padding:1em;
}
//   input {
//   background-color: blueviolet;
//   color: white;
//   padding: 1em;
//   border-radius: 1em;
//   border: 2px solid white;
//   margin: 1em;
// }

input {
  padding: 0.5em;
  border: 4px solid black;
  margin-bottom: 1em;
}

button {
  background-color: blueviolet;
  color: white;
  padding-top: .5em;
  padding-bottom: .5em;
  border-radius: 1em;
  border: 2px solid white;
  margin: 1em;

  &:hover {
  background-color: #892be29a;
  cursor: pointer;
}
}

</style>
